import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

export const Container = styled.div`
  position: relative;

  display: flex;
  gap: 4px;
  align-items: center;

  margin-block-end: 8px;

  color: #666666;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 19.36px;
  letter-spacing: 0.5px;

  & > div {
    line-height: 0;

    cursor: pointer;
  }
`;

export const IconInfoContainer = styled.div`
  position: relative;

  inline-size: 16px;
  block-size: 16px;
`;
